class pdpFlavourProduct extends HTMLElement {
    constructor() {
        super()
        this.addEventListener('click', this.handleClick)
    }

    handleClick() {
     
        this.image  = this.dataset.dropProductImage
        this.handle = this.dataset.productHandle

        document.querySelectorAll('flavour-product').forEach(elm => {
            elm.classList.remove('selected');
        })

        this.classList.add('selected');

        const container = document.querySelector('[js-pdp-custom-products-drop-container]')
        const dropHeader = container.querySelector('[js-drop-header]')
        const title = dropHeader.querySelector('[js-flavor-product-title]')

        title.innerHTML = this.querySelector('.flavor-product_title').innerHTML

        // render new contents
        this.updateHistoryState(this.handle)
        this.renderSections(this.handle)
    }

    getSectionsToRender() {
        return [
            {
                selector: "js-header-sticky-btn",
                sectionId: document.querySelector("[js-header-sticky-btn]")?.dataset.section
            },
            {
                selector: "js-main-product",
                sectionId: document.querySelector("[js-main-product]")?.dataset.section
            },
            {
                selector: "js-pdp-review-section",
                sectionId: document.querySelector("[js-pdp-review-section]")?.dataset.section
            },
            {
                selector: "js-pdp-product-recommendations-section",
                sectionId: document.querySelector("[js-pdp-product-recommendations-section]")?.dataset.section
            },
        ]
    }

    renderSections(handle) {
        this.getSectionsToRender().forEach(section=> {
            console.log({ section })

           if(section.sectionId != undefined) {
              fetch(`/products/${handle}?section_id=${section.sectionId}`)
              .then(response=>response.text())
              .then(html=>{
  
                  const doc = new DOMParser().parseFromString(html, "text/html");
                  const elementToReplace = document.querySelector(`[${section.selector}]`);
                
                  if(elementToReplace && doc.querySelector(`[${section.selector}]`)) {
                      elementToReplace.innerHTML ='';
                      elementToReplace.innerHTML = doc.querySelector(`[${section.selector}]`).innerHTML
                  }

                  switch (section.selector) {
                    case "js-main-product":
                        document.dispatchEvent(new CustomEvent('customPDPDrop:init'))
                        document.dispatchEvent(new CustomEvent('pdpCustomDrop:reinit'))
                        document.dispatchEvent(new CustomEvent('PDPImageSlider:init'))
                        document.dispatchEvent(new CustomEvent('dpdExtaInfoDrawer:init'))
                        document.dispatchEvent(new CustomEvent('klaviyoCustomEvents:init'))
                        okeWidgetApi.initAllWidgets()
                        document.title = doc.querySelector("[js-flavor-product-title]").innerText;
                        PRIVE_WIDGET.PriveWidget.init()
                         window?.pdpButtonsScript()
                    break;
                    case "js-pdp-review-section":
                        okeWidgetApi.initAllWidgets()
                      break;
                  }
                 
              }).catch(function(error) {
                  console.log(error)
              })
           }
        }
        )
    }

    updateHistoryState(handle) {
        var newurl = `${window.location.protocol}//${window.location.host}/products/${handle}`;
        window.history.pushState({
            path: newurl
        }, "", newurl)
    }
}

customElements.define('flavour-product', pdpFlavourProduct)

